import { flowRight, get } from 'lodash/fp';
import { withPropsOnChange } from 'recompose';
import { formValues } from 'redux-form';

const withTargetRecommendations = flowRight([
    formValues('target', 'choicePreco', 'reductionAmount', 'fundingAmount', 'costAmount', 'investmentPercentage', 'incomes', 'fiscalPart'),
    withPropsOnChange(['rip', 'target', 'choicePreco', 'reductionAmount', 'fundingAmount', 'costAmount', 'investmentPercentage', 'incomes', 'fiscalPart'], ({ rip, target, choicePreco, reductionAmount, fundingAmount, costAmount, investmentPercentage, incomes, fiscalPart }) => {
        let name;
        if ('cif' !== choicePreco) {
            name = 'partner.recommendations';
        } else if ('clientAndPartner' === target) {
            name = 'recommendationsCIFClientAndPartner';
        } else {
            name = 'partner.recommendationsCIF';
        }

        let recommendationsPath;
        if ('partner' === target) {
            recommendationsPath = 'partner.recommendationsCIF';
        } else if ('clientAndPartner' === target) {
            recommendationsPath = 'recommendationsCIFClientAndPartner';
        } else {
            recommendationsPath = 'recommendationsCIF';
        }

        return {
            recommendations: get(recommendationsPath, rip),
            name,
            choicePreco,
            enveloppe: { reductionAmount, fundingAmount, costAmount, investmentPercentage },
            incomes,
            fiscalPart,
        };
    }),
]);

export default withTargetRecommendations;
